// extracted by mini-css-extract-plugin
module.exports = {"controls":"Controls_controls__24J4w","button":"Controls_button__3gNUk"};